export default {
    methods: {
        //emits apply transition
        emitApplyTransition(transition, fromType) {
            this.$emit('applyTransition', transition, fromType);
        },
    },
};
